import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { X, Minus, Plus, Trash2 } from "lucide-react";
import { useCart } from "../contexts/CartContext";
import { MEDIA } from "../lib/api";

export default function CartDrawer() {
    const { cart, open, setOpen, updateQty, removeItem } = useCart();
    const navigate = useNavigate();

    if (!open) return null;
    const fmt = (n) => `${(n || 0).toFixed(2)} RON`;

    return (
        <div className="fixed inset-0 z-[200]" data-testid="cart-drawer">
            <div className="absolute inset-0 bg-foreground/50 backdrop-blur-sm" onClick={() => setOpen(false)} />
            <div className="absolute right-0 top-0 bottom-0 w-full max-w-md bg-card shadow-xl flex flex-col">
                <div className="flex items-center justify-between p-5 border-b border-border">
                    <h3 className="font-heading text-xl">Coșul tău</h3>
                    <button onClick={() => setOpen(false)} data-testid="cart-close-btn" className="btn-ghost"><X className="h-5 w-5" /></button>
                </div>
                <div className="flex-1 overflow-y-auto p-5 space-y-3">
                    {(cart.items || []).length === 0 && (
                        <div className="text-center py-16 text-muted-foreground">Coșul este gol</div>
                    )}
                    {(cart.items || []).map((it, idx) => (
                        <div key={idx} className="flex gap-3 card-soft p-3" data-testid={`cart-item-${idx}`}>
                            <div className="w-20 h-20 bg-muted rounded-lg flex-shrink-0 overflow-hidden">
                                {it.image && <img src={MEDIA(it.image)} alt={it.name} className="w-full h-full object-cover" />}
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="font-medium text-sm line-clamp-2">{it.name}</div>
                                <div className="text-xs text-primary mt-1">{fmt(it.unit_price)}</div>
                                <div className="flex items-center justify-between mt-2">
                                    <div className="flex items-center rounded-lg border border-border">
                                        <button className="px-2 py-1 hover:bg-muted rounded-l-lg" onClick={() => updateQty(it.product_id, it.package_id, it.quantity - 1)}><Minus className="h-3 w-3" /></button>
                                        <span className="px-3 text-sm">{it.quantity}</span>
                                        <button className="px-2 py-1 hover:bg-muted rounded-r-lg" onClick={() => updateQty(it.product_id, it.package_id, it.quantity + 1)}><Plus className="h-3 w-3" /></button>
                                    </div>
                                    <button onClick={() => removeItem(it.product_id, it.package_id)} className="text-destructive p-1" data-testid={`cart-remove-${idx}`}><Trash2 className="h-4 w-4" /></button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {(cart.items || []).length > 0 && (
                    <div className="border-t border-border p-5 space-y-3 bg-muted/30">
                        <div className="flex justify-between text-sm">
                            <span className="text-muted-foreground">Subtotal</span><span>{fmt(cart.subtotal)}</span>
                        </div>
                        {(cart.user_discount_amount || 0) > 0 && (
                            <div className="flex justify-between text-sm text-primary">
                                <span>Discount cont (-{cart.user_discount_percent}%)</span><span>-{fmt(cart.user_discount_amount)}</span>
                            </div>
                        )}
                        <div className="flex justify-between font-heading text-lg">
                            <span>Total</span><span className="text-primary">{fmt(cart.total)}</span>
                        </div>
                        <button onClick={() => { setOpen(false); navigate("/checkout"); }} className="btn-primary w-full" data-testid="cart-checkout-btn">Finalizează comanda</button>
                        <Link to="/cos" onClick={() => setOpen(false)} className="block text-center text-xs text-muted-foreground hover:text-foreground" data-testid="cart-view-page">Vezi coșul →</Link>
                    </div>
                )}
            </div>
        </div>
    );
}
